<script>
import { convertCurrency } from '~/assets/js/methods';
export default {
    name: 'OrderbumpCheckbox',
    props: ['dataOrderbump'],
    setup() {
        return {
            convertCurrency
        }
    },
    watch: {
        checked: {
            handler(e) {
                this.$emit('checked', {
                    checked: e,
                    item: {
                        id: this.dataOrderbump.id,
                        hash: this.dataOrderbump.product_hash,
                        product_id: this.dataOrderbump.product_id,
                        offer_id: this.dataOrderbump.offer_id,
                        title: this.dataOrderbump.product_title,
                        cover: this.dataOrderbump.cover,
                        price: parseInt(this.dataOrderbump.price),
                        quantity: 1,
                        operation_type: 2
                    }
                });
            }
        }
    },
    data() {
        return {
            checked: ""
        }
    }
}
</script>
<template>
    <div class="border-b last:border-b-0 border-orange-200" :class="{ 'bg-orange-50': checked }">
        <label class="relative cursor-pointer rounded-md focus:outline-none overflow-hidden" @click.stop>
            <input type="checkbox" :name="`orderbump-${dataOrderbump.id}`" v-model="checked" :value="dataOrderbump.id"
                class="sr-only" :aria-labelledby="`orderbump-${dataOrderbump.id}-label`"
                :aria-describedby="`orderbump-${dataOrderbump.id}-description-${dataOrderbump.id}`">
            <span class="flex flex-wrap px-2 py-2">
                <span class="flex flex-auto align-middle items-center">
                    <div v-if="dataOrderbump.cover" class="w-5/12">
                        <img :src="dataOrderbump.cover">
                    </div>
                    <div class="leading-none p-1 w-full" :class="{ 'ml-2 w-7/12': dataOrderbump.cover }">
                        <span class="text-lg leading-none font-bold text-blue-700 rounded-t-md w-full block">{{
                            (dataOrderbump.title)
                            ? dataOrderbump.title : dataOrderbump.product_title }}</span>
                        <span class="text-md text-gray-700 block w-full">{{ dataOrderbump.description }}</span>
                        <span class="mt-1 text-lg font-medium text-gray-900 block w-full leading-none"><span
                                class="text-green-600 text-md">{{ (convertCurrency(dataOrderbump.price / 100,
                                    'R$ ')) }}</span></span>
                    </div>
                </span>
            </span>

            <span class="flex flex-row items-center px-2 py-2">
                <span class="flex-col">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                        y="0px" viewBox="0 0 512 512" xml:space="preserve" class="w-10 h-10 text-red-600">
                        <g>
                            <path fill="currentColor" d="M481,256L263.3,38.3v130.6H31v174.2h232.3v130.6L481,256z"></path>
                        </g>
                    </svg>
                </span>
                <span class="w-8">
                    <img v-if="checked" src="/img/checked.png" class="w-6 h-6">
                    <img v-else src="/img/unchecked.png" class="w-6 h-6">
                </span>
                <span class="flex-col text-base ml-2 leading-none font-bold text-red-700">{{
                    dataOrderbump.call_to_action
                }}</span>
            </span>
            <span class="pointer-events-none absolute -inset-px rounded-lg"
                :class="{ 'border-green-700': checked, 'border-gray-800': !checked }" aria-hidden="true"></span>
        </label>
    </div>
</template>
